import { ByStringId } from "lib/types/common";

export enum ChatCurrentState {
  HOME = "home",
  NEW_MESSAGE = "newMessage",
  MESSAGE_THREAD = "messageThread",
}

export enum MessageType {
  TEXT = "text",
  PHOTO = "photo",
  PHOTO_B64 = "photoB64",
}

// Note - one of these is incorrect
export interface ChatMessage {
  refId: string;
  recipientUsrRefId: string | null;
  senderUsrRefId: string;
  superAdminSenderUsrRefId: string | null;
  sentByOrganization: boolean;
  usrRefId: string;
  message: string;
  parentMessageRefId: string;
  createdAt: string; //date
  removedAt: string | null;
  updatedAt: string | null;
  authorizationToken: string | null;
  isCloseConnection: boolean;
  isTyping: boolean;
  isPing: boolean;
  // should these be here?
  imageUrl?: string | null;
  PathToImage: string | null;
  ImageRemoteStore: string;
  b64ImageContent: string | null;
  type?: ServerMessageType;
  usrProfileImageUrl?: string | null;
  usrFirstName?: string;
  usrLastName?: string;
  usrJobTitle?: string;
}

export enum ServerMessageType {
  ORGANIZATION = "organization",
  SUPPORT = "support",
}
export type ChatThreads = ByStringId<ChatMessage[]>;

export interface ChatMessageOut {
  message?: string;
  b64ImageContent?: string;
  usrRefId: string;
}

export interface FullChatMessageOut extends ChatMessageOut {
  authorizationToken: string;
}
